import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule } from '@fuse/components/sidebar/sidebar.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ApprovalsEquipmentsComponent } from './approvals-equipments.component';
import { DialogApprovalsEquipmentsDiffModule } from './dialog/dialog-approvals-diff/dialog-approvals-equipments.module';
import { DialogApprovalsEquipmentsModule } from './dialog/dialog-approvals-new/dialog-approvals-equipments.module';
import { FilterApprovalsEquipmentsModule } from './filter/filter-approvals-equipments.module';
import { ApprovalsEquipmentsApi } from './services/api/approvals-equipments-api.service';
import { ApprovalsEquipmentsService } from './services/approvals-equipments.service';


const routes: Routes = [
  {
    path: 'equipamentos/aprovacoes',
    component: ApprovalsEquipmentsComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.EQUIPMENTS.APPROVALS' }
  }
];

@NgModule({
  declarations: [
    ApprovalsEquipmentsComponent
  ],
  imports: [
    RouterModule.forChild(routes),

    TranslateModule,
    FuseSharedModule,
    FuseSidebarModule,

    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatProgressSpinnerModule,

    FilterApprovalsEquipmentsModule,
    DialogApprovalsEquipmentsModule,
    DialogApprovalsEquipmentsDiffModule
  ],
  exports: [
    ApprovalsEquipmentsComponent
  ],
  providers: [ApprovalsEquipmentsService, ApprovalsEquipmentsApi]
})

export class ApprovalsEquipmentsModule {
}
